import { connect, useSelector } from "react-redux";
import {
  UpdateSingleAuthDataInput,
  UpdateSingleAuthDataInputError,
  UserProps,
} from "../../store/actionType";
import ChangeNameForm from "./components/ChangeNameForm";
import { updatedSingleUserName } from "../../store/action";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";

type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  userData: UserProps;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleNameChange: React.FC<Props> = ({
  closeModal,
  onUpdateUserName,
  userData,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [formData, setFormData] = useState<UpdateSingleAuthDataInput>({
    field: "name",
    value: userData.name,
    password: "",
  });
  const userState = useSelector((state: any) => state.users.genericUserState);
  const [error, setError] = useState<UpdateSingleAuthDataInputError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const errors: UpdateSingleAuthDataInputError = {};
    if (!formData.value.trim()) errors.value = "Name is required";
    if (!formData.password.trim()) errors.password = "Password is required";
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (formData.value.trim() !== "" && formData.password.trim() !== "") {
      setSubmitted(true);
      setLoading(true);
      const input = {
        value: formData.value || "",
        field: formData.field || "name",
        password: formData.password || "",
      };
      try {
        await onUpdateUserName(input, userData.id);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (!userState.isLoading && submitted) {
      if (userState.error) {
        setApiError(userState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [userState?.isLoading, userState?.error, submitted, closeModal]);
  return (
    <>
      <ChangeNameForm
        fieldValue="Name"
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Change Name"}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateUserName: (input: UpdateSingleAuthDataInput, user_id:string) =>
    dispatch(updatedSingleUserName(input, user_id)),
});
export default connect(null, mapDispatchToProps)(HandleNameChange);
